<template lang="pug">
  #section3.section
    #s3s1
    Carousel
    #s3s2
      #s3s2a1.group
        #s3s2a1b1
          .fake-header
          .block  
            .slide
              img(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
                src="/assets/Mobile/Section3/3.7.1 Reparación Integral.jpg")
              p.bold(
                data-sal="fade"
                data-sal-delay="50"
                data-sal-easing="ease"
              )  En 2017, la CEAV logró integrar los expedientes de las víctimas directas e indirectas para que lograran incorporarse al Registro Nacional de Víctimas.
          .fake-footer
</template>
<script>
import sal from "sal.js";
import Carousel from "./Carousel.vue";

export default {
  name: "Section3",
  components: {
    Carousel
  },
  methods: {
    initialize() {
      sal({
        threshold: 0.4,
        once: false
      });
    }
  },
  mounted() {
    this.initialize();
  }
};
</script>
<style lang="scss" scoped>
#s3s2a1 {
  height: 200vh;
  background-color: #000;
  #s3s2a1b1 {
    .fake-header {
      @include fakinH(4vh, 0%);
    }
    .fake-footer {
      @include fakinF(1.6vh, 7%);
    }
    .block {
      @include blockin(100%, 80%, 5%, 0%);
      img {
        @include blockinImg(80%, 55vh, 20%);
        margin-bottom: 16%;
      }
      p {
        @include blockinP(80%, 65%, 10%);
      }
    }
  }
}
</style>
